import Vue from "vue";
import {
  Button,
  Icon,
  Image as VanImage,
  DatetimePicker,
  Popup,
  Tabbar,
  TabbarItem,
  NavBar,
  Swipe,
  SwipeItem,
  Toast,
  Tab,
  Tabs,
  Field,
  IndexBar,
  IndexAnchor,
  Cell,
  CellGroup,
  Popover,
  Loading,
  Overlay
} from "vant";
Vue.use(Button)
  .use(Icon)
  .use(VanImage)
  .use(DatetimePicker)
  .use(Popup)
  .use(Tabbar)
  .use(TabbarItem)
  .use(Swipe)
  .use(SwipeItem)
  .use(Toast)
  .use(Tab)
  .use(Tabs)
  .use(Field)
  .use(IndexBar)
  .use(IndexAnchor)
  .use(Cell)
  .use(CellGroup)
  .use(Popover)
  .use(Loading)
  .use(Overlay)
  .use(NavBar);
